import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// USD /result_complete?safe&mock-data&utm_source=FB&country=IN&area=female&exp=web_reprice_upsells_nonus~1
			// EUR /result_complete?safe&mock-data&utm_source=FB&country=DE&area=female&exp=web_reprice_upsells_nonus~1
			// CAD /result_complete?safe&mock-data&utm_source=FB&country=CA&area=female&exp=web_reprice_upsells_nonus~1
			// GBP /result_complete?safe&mock-data&utm_source=FB&country=GBP&area=female&exp=web_reprice_upsells_nonus~1
			upsell: {
				experiment: {
					'upsell-f': () =>
						import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/experiments/web_reprice_upsells_nonus'),
				},
			},
		},
		'female-water-fasting': {
			// USD /result_complete?safe&mock-data&utm_source=FB&country=IN&area=female-water-fasting&exp=web_reprice_upsells_nonus~1
			// EUR /result_complete?safe&mock-data&utm_source=FB&country=DE&area=female-water-fasting&exp=web_reprice_upsells_nonus~1
			// CAD /result_complete?safe&mock-data&utm_source=FB&country=CA&area=female-water-fasting&exp=web_reprice_upsells_nonus~1
			// GBP /result_complete?safe&mock-data&utm_source=FB&country=GBP&area=female-water-fasting&exp=web_reprice_upsells_nonus~1
			upsell: {
				experiment: {
					'upsell-f': () =>
						import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/experiments/web_reprice_upsells_nonus'),
				},
			},
		},
		'activity-female-tai-chi-walking-v2': {
			// USD /result_complete?safe&mock-data&utm_source=FB&country=IN&area=activity-female-tai-chi-walking-v2&exp=web_reprice_upsells_nonus~1
			// EUR /result_complete?safe&mock-data&utm_source=FB&country=DE&area=activity-female-tai-chi-walking-v2&exp=web_reprice_upsells_nonus~1
			// CAD /result_complete?safe&mock-data&utm_source=FB&country=CA&area=activity-female-tai-chi-walking-v2&exp=web_reprice_upsells_nonus~1
			// GBP /result_complete?safe&mock-data&utm_source=FB&country=GBP&area=activity-female-tai-chi-walking-v2&exp=web_reprice_upsells_nonus~1
			upsell: {
				experiment: {
					'upsell-tai-chi-walking-f': () =>
						import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/experiments/web_reprice_upsells_nonus'),
				},
			},
		},
		'activity-female-tai-chi-walking-v2-al': {
			// USD /result_complete?safe&mock-data&utm_source=FB&country=IN&area=activity-female-tai-chi-walking-v2-al&exp=web_reprice_upsells_nonus~1
			// EUR /result_complete?safe&mock-data&utm_source=FB&country=DE&area=activity-female-tai-chi-walking-v2-al&exp=web_reprice_upsells_nonus~1
			// CAD /result_complete?safe&mock-data&utm_source=FB&country=CA&area=activity-female-tai-chi-walking-v2-al&exp=web_reprice_upsells_nonus~1
			// GBP /result_complete?safe&mock-data&utm_source=FB&country=GBP&area=activity-female-tai-chi-walking-v2-al&exp=web_reprice_upsells_nonus~1
			upsell: {
				experiment: {
					'upsell-tai-chi-walking-f': () =>
						import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/experiments/web_reprice_upsells_nonus'),
				},
			},
		},
	},
]

export default config
